import { render, staticRenderFns } from "./StatisticsReferralProgram.vue?vue&type=template&id=4bbd70cf&"
import script from "./StatisticsReferralProgram.vue?vue&type=script&lang=js&"
export * from "./StatisticsReferralProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports